// src/api/index.js
import axios from 'axios';
import {error, warning} from "@/utils/elMessage";
import {loading} from "@/components/comment/loading/loading";
import router from "@/router";
import store from "@/store";
import {ElMessageBox} from "element-plus";
import {isContains} from "@/utils/fun";


const interceptorsPath = {
    prefix: ['admin']
}

// 全局请求 loading 默认关闭，避免每次接口请求都全屏闪一下。
// 如果某个耗时接口确实需要全屏 loading，可以在请求 config 里传：{ showLoading: true }
let requestLoadingCount = 0
let requestLoadingTimer = null
const REQUEST_LOADING_DELAY = 450

const startRequestLoading = (config) => {
    const showGlobalLoading = config && config.showLoading === true
    config._showGlobalLoading = showGlobalLoading
    if (!showGlobalLoading) return

    requestLoadingCount += 1
    if (requestLoadingTimer) return

    requestLoadingTimer = setTimeout(() => {
        requestLoadingTimer = null
        if (requestLoadingCount > 0) {
            loading.show()
        }
    }, REQUEST_LOADING_DELAY)
}

const closeRequestLoading = (config) => {
    if (!config || config._showGlobalLoading !== true) return

    requestLoadingCount = Math.max(0, requestLoadingCount - 1)
    if (requestLoadingCount > 0) return

    if (requestLoadingTimer) {
        clearTimeout(requestLoadingTimer)
        requestLoadingTimer = null
    }
    loading.hide()
}



let refreshTokenPromise = null
/**
 * 刷新Token并重试请求的函数
 * @param originalRequest
 * @param fun
 */
const refreshTokenAndRetry = async (originalRequest, fun) => {
    if (!refreshTokenPromise) { // 如果没有正在进行的刷新Token操作，则开始一个新的
        refreshTokenPromise = store.dispatch('user/REFRESH_TOKEN')
            .then(_ => {
                // 成功刷新后清除promise以便下次使用
                refreshTokenPromise = null;
            })
            .catch(err => {
                // 刷新失败时也清除promise以便下次尝试
                refreshTokenPromise = null;
                return Promise.reject(new Error('请先登录~'))
            });
    }

    try {
        await refreshTokenPromise

        return fun(originalRequest)
    } catch (e) {
        error({msg: '请先登录~', duration: 5 * 1000})
        // router.push({ path: '/login'}).then(_=>{})

        ElMessageBox.confirm('是否进行登录？', {confirmButtonText: '确认', cancelButtonText: '取消'})
            .then(_ => {
                store.dispatch('user/LOGIN_OUT').then(_ => {
                }).catch(_ => {
                })
                router.push({path: '/login'}).then(_ => {
                }).catch(_ => {
                })
            })
            .catch(_ => {
            })
        return Promise.reject(new Error('请先登录~'))
    }
}

/**
 * axios创建
 * @param prefix 前缀
 */
const createApiClient = (prefix) => {
    const apiClient = axios.create({
        baseURL: `${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_API_PREFIX}/${prefix}/`,
        // 过期时间
        timeout: 60000,
    });
    // 请求拦截
    apiClient.interceptors.request.use(config => {
        startRequestLoading(config)
        config.headers['auth'] = 'auth'
        if (store.getters["user/isLogin"]) {
            config.headers['Authorization'] = 'Bearer ' + store.getters["user/token"]
            // config.headers['refreshAuthorization'] = 'Bearer ' + store.getters["user/refreshToken"]
        }
        if (config.url === '/refresh-token') {
            config.headers['refreshAuthorization'] = 'Bearer ' + store.getters["user/refreshToken"]
        }

        if (isContains(interceptorsPath.prefix, prefix)) {
            if (!store.getters["user/isLogin"]) {
                closeRequestLoading(config)
                return Promise.reject({
                    status: 4001,
                    msg: '请先登录后使用~'
                });
            }
        }

        return config
    }, err => {
        console.log('异常')
        closeRequestLoading(err.config)
        error({msg: err.msg || '系统异常', duration: 5 * 1000})
        return Promise.reject(err)
    })

    // 响应拦截
    apiClient.interceptors.response.use(response => {
        closeRequestLoading(response.config)
        if (response.status !== 200) {
            error({msg: '系统异常', duration: 5 * 1000})
            return Promise.reject('系统异常')
        }
        if (response.request.responseType === 'blob') {
            return response
        }
        const {code, success} = response.data
        if (success) {
            return response.data.data
        }
        if (code === 401) {
            if (response.config && response.config.skipAuthRefresh) {
                return Promise.reject(new Error(response.data.msg || '登录状态已失效'))
            }
            return refreshTokenAndRetry(response.config, apiClient)
        }
        if (code === 403) {
            error({msg: response.data.msg || '权限不足', duration: 5 * 1000})
            return Promise.reject(new Error(response.data.msg || '权限不足'))
        }
        if (code === 500) {
            error({msg: response.data.msg || '系统异常', duration: 5 * 1000})
            return Promise.reject(new Error(response.data.msg || '系统异常'))
        }
    }, err => {
        closeRequestLoading(err.config)
        if (err.status === 404) {
            error({msg: '请求404', duration: 5 * 1000})
            return Promise.reject(err)
        }
        if (err.status === 403) {
            error({msg: '拒绝访问403', duration: 5 * 1000})
            return Promise.reject(err)
        }
        if (err.status === 4001) {
            warning({msg: err.msg || '请先登录后使用~', duration: 5 * 1000})
            return Promise.reject(err)
        }
        error({msg: err.msg || '系统异常', duration: 5 * 1000})
        return Promise.reject(err)
    })

    return apiClient
}

/**
 * 后台
 */
const adminRequest = createApiClient('admin')
/**
 * 认证
 */
const authRequest = createApiClient('auth')

export {
    adminRequest,
    authRequest
}
